
import { BannerDto } from '../../../dto/banner/bannerdto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';


export interface BannerRequest extends APIRequest
{
    getBannerRequest(): BannerDto;
}

export class BannerRequestImpl extends APIRequestDtoImpl implements BannerRequest
{
    constructor(private bannerData: BannerDto)
    {
        super();
    }

    getBannerRequest(): BannerDto
    {
        return this.bannerData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/banner/getbanner/bannerrequest.tsx